import React, { useEffect, useState } from "react";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { CloseIcon, PlayIcon, StopIcon, TimerIcon } from "../../assets/images";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import { LoginResponseType } from "../../redux/auth/authTypes";
import {
  addAttendanceTimeAction,
  getAttendanceDataAction,
  resetAttendanceStatusCode,
  resetAttendenceData,
  resetAttendenceError,
  resetAttendenceSuccess,
  resetAuthError,
  resetAuthSuccess,
  resetSession,
  setLocationDetails,
} from "../../redux/auth";
import moment from "moment";
import AttendanceList from "../../components/commons/Attendance/AttendanceList";
import {
  AddAttendanceTimePayloadType,
  GetAttendanceTimePayloadType,
} from "../../commonTypes/authTypes";
import { ErrorSuccessModal } from "../../components/commons";
import { AttendanceDataType } from "../../redux/notification/notificationTypes";
import {
  getSchedulingNotificationCountAction,
  resetScheduleNotificationCount,
} from "../../redux/notification";
import { GetSchedulingNotificationCountPayloadType } from "../../commonTypes/notificationType";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import { style } from "./Style/style";
import useDebounce from "../../customHooks/useDebounce";
import TimerComponent from "../../components/commons/Attendance/RotateTimer/TimerIcon";

export const getWellcomeMessage = () => {
  const currentHour = new Date().getHours();

  let message;
  if (currentHour < 12) {
    message = "🌞 Good Morning";
  } else if (currentHour < 17) {
    message = "🌤️ Good Afternoon";
  } else {
    message = "🌙 Good Evening";
  }

  return message;
};

type AppProps = {
  token: string | null;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  attendanceStatusCode: number | null;
  loginData: LoginResponseType;
  seconds: number;
  minutes: number;
  hours: number;
  startTimer: boolean;
  fetching: boolean;
  setSeconds: React.Dispatch<React.SetStateAction<number>>;
  setMinutes: React.Dispatch<React.SetStateAction<number>>;
  setHours: React.Dispatch<React.SetStateAction<number>>;
  setStartTimer: React.Dispatch<React.SetStateAction<boolean>>;
  dispatchGetAttendanceDataAction: (data: GetAttendanceTimePayloadType) => void;
  dispatchAddAttendanceTimeAction: (data: AddAttendanceTimePayloadType) => void;
  dispatchGetSchedulingNotificationCountAction: (
    data: GetSchedulingNotificationCountPayloadType
  ) => void;
  dispatchResetAttendenceData: () => void;
  dispatchResetError: () => void;
  dispatchResetAttendanceSuccess: () => void;
  dispatchResetSession: () => void;
  dispatchResetScheduleNotificationCount: () => void;
  dispatchResetAttendanceStatusCode: () => void;
  attendenceData: any;
  totalAttendanceHours: number;
  latitude: string;
  longitude: string;
  location: string;
  locationCityName: string;
  startingAttendenceData: AttendanceDataType | null;
  dispatchSetLocationDetails: (data: any) => void;
  setTimerStartMessage: React.Dispatch<React.SetStateAction<string>>;
};

const Attendance = ({
  token,
  fetching,
  success,
  statusCode,
  attendanceStatusCode,
  error,
  loginData,
  seconds,
  minutes,
  hours,
  startTimer,
  setSeconds,
  setMinutes,
  setHours,
  setStartTimer,
  dispatchGetAttendanceDataAction,
  attendenceData,
  dispatchAddAttendanceTimeAction,
  dispatchSetLocationDetails,
  totalAttendanceHours,
  dispatchResetAttendenceData,
  dispatchResetError,
  dispatchResetAttendanceSuccess,
  dispatchResetSession,
  latitude,
  longitude,
  location,
  locationCityName,
  startingAttendenceData,
  dispatchGetSchedulingNotificationCountAction,
  dispatchResetScheduleNotificationCount,
  dispatchResetAttendanceStatusCode,
  setTimerStartMessage,
}: AppProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [addApiCall, setAddApiCall] = useState<boolean>(false);
  const [buttonColor, setButtonColor] = useState<boolean>(false);
  const [buttonName, setButtonName] = useState<string>("");
  const currentDate = new Date();
  const presentTime = moment(currentDate).format("hh:mm A");
  const todayDate = moment(currentDate).format("DD-MM-YYYY");
  const [loading, setLoading] = useState(false);
  const googleMapKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
  const googleMapApi = process.env.REACT_APP_GOOGLE_MAP_API;

  useEffect(() => {
    dispatchResetError();
    setTimerStartMessage(buttonName);
  }, [buttonName]);

  useEffect(() => {
    if (startingAttendenceData == null) {
      setButtonName("Check In");
      setHours(0);
      setMinutes(0);
      setSeconds(0);
      setStartTimer(false);
    } else if (
      startingAttendenceData?.start_time &&
      startingAttendenceData?.is_started === 1 &&
      startingAttendenceData != null
    ) {
      setButtonName("Stop");
      setStartTimer(true);
      setPresentTime();
    } else if (
      startingAttendenceData?.start_time &&
      startingAttendenceData?.is_started === 0
    ) {
      setPresentTime();
      setButtonName("Start Timer");
      setStartTimer(false);
    }
  }, [startingAttendenceData?.is_started]);

  useEffect(() => {
    if (!loading) {
      dispatchResetAttendanceStatusCode();
      setPresentTime();
      setAddApiCall(true);
      if (buttonName === "Check In") {
        dispatchResetScheduleNotificationCount();
        setButtonName("Stop");
        setStartTimer(true);
        const finalData = {
          token,
          date: todayDate,
          startTime: presentTime,
          location,
          latitude,
          longitude,
        };
        dispatchAddAttendanceTimeAction(finalData);
        const data = {
          token,
        };
        dispatchGetSchedulingNotificationCountAction(data);
      } else if (buttonName === "Stop") {
        setStartTimer(false);
        setButtonName("Start Timer");
        const finalData = {
          token,
          date: todayDate,
          endTime: presentTime,
          location,
          latitude,
          longitude,
        };
        dispatchAddAttendanceTimeAction(finalData);
      } else if (buttonName === "Start Timer") {
        setPresentTime();
        setStartTimer(true);
        setButtonName("Stop");
        const finalData = {
          token,
          date: todayDate,
          startTime: presentTime,
          location,
          latitude,
          longitude,
        };
        dispatchAddAttendanceTimeAction(finalData);
      }
    }
  }, [loading]);
  // Future use
  // useEffect(() => {
  //   dispatchResetAttendanceSuccess();
  //   if (token && (buttonName === "Start Timer" || buttonName === "Stop")) {
  //     dispatchResetAttendenceData();
  //     const finalData = {
  //       token,
  //       date: todayDate,
  //     };
  //     dispatchGetAttendanceDataAction(finalData);
  //   }
  // }, [buttonName]);

  useDebounce(
    () => {
      dispatchResetAttendanceSuccess();
      if (token && (buttonName === "Start Timer" || buttonName === "Stop")) {
        dispatchResetAttendenceData();
        const finalData = {
          token,
          date: todayDate,
        };
        dispatchGetAttendanceDataAction(finalData);
      }
    },
    1000,
    [buttonName]
  );

  useEffect(() => {
    const currentHour = new Date().getHours();
    const currentMinutes = new Date().getMinutes();
    const currentSeconds = new Date().getSeconds();
    let interval: any = null;
    if (currentHour === 23 && currentMinutes === 59 && currentSeconds === 59) {
      const finalData = {
        token,
        date: todayDate,
        endTime: presentTime,
        location,
        latitude,
        longitude,
      };
      dispatchAddAttendanceTimeAction(finalData);
      setStartTimer(false);
      setButtonName("Check In");
      setHours(0);
      setMinutes(0);
      setSeconds(0);
      return () => {
        clearInterval(interval);
      };
    }
    if (startTimer && currentHour < 24) {
      interval = setInterval(() => {
        setSeconds(() => seconds + 1);
        if (seconds >= 59) {
          setSeconds(0);
          setMinutes(minutes + 1);
        } else if (minutes >= 59) {
          setMinutes(0);
          setHours(hours + 1);
        }
      }, 1000);
    }
    return () => {
      clearInterval(interval);
    };
  });

  const handleStartTimer = (buttonName: string) => {
    getLocation();
    setButtonName(buttonName);
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (attendanceStatusCode === 401) {
        setStartTimer(false);
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (
        !!error &&
        attendanceStatusCode &&
        attendanceStatusCode !== 401
      ) {
        setStartTimer(false);
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetError();
              dispatchResetAttendanceStatusCode();
            }}
          />
        );
      }
      // else if (!!error && statusCode !== 401) {
      //   return (
      //     <ErrorSuccessModal
      //       type="error"
      //       isOpen={!!error}
      //       title="Error"
      //       message={error}
      //       buttonText="OK"
      //       onPress={() => {
      //         dispatchResetError();
      //       }}
      //     />
      //   );
      // }
    }
  };

  const setPresentTime = () => {
    if (startingAttendenceData?.start_time) {
      const startTime = moment(startingAttendenceData?.start_time, "h:mm A");
      const endTime = moment(presentTime, "h:mm A");
      const timeDifference = moment.duration(endTime.diff(startTime));
      const hours = Math.floor(timeDifference.asHours());
      const minutes = Math.floor(timeDifference.asMinutes()) % 60;
      setHours(hours);
      setMinutes(minutes);
    }
  };

  //Get User Location
  const getLocation = () => {
    setLoading(true);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          const apiUrl = `${googleMapApi}=${latitude},${longitude}&key=${googleMapKey}`;

          try {
            const locationResponse = await axios.get(apiUrl);
            const finalLocation =
              locationResponse?.data?.results[0]?.formatted_address;
            dispatchSetLocationDetails(finalLocation);
          } catch (error: any) {
            toast.error("Error fetching area!", {
              duration: 3000,
            });
          } finally {
            setLoading(false);
          }
        },
        (error) => {
          if (window.console) {
            toast.error("Error getting location!", {
              duration: 3000,
            });
            dispatchSetLocationDetails("");
            setLoading(false);
          }
        },
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
      );
    } else {
      toast.error("Geolocation is not supported by your browser.!", {
        duration: 3000,
      });
      setLoading(false);
    }
  };

  return (
    <>
      <ButtonDropdown
        isOpen={isOpen}
        toggle={() => {
          setIsOpen(!isOpen);
        }}
      >
        <DropdownToggle style={style.screen_attendance_container}>
          <div>
            {startTimer && !isOpen ? (
              <span style={{ marginRight: "7px" }}>
                <TimerComponent />
              </span>
            ) : (
              <img style={{ marginRight: "7px" }} src={TimerIcon} />
            )}
            <span
              style={{
                color: "#262a44",
                fontSize: "14px",
                fontWeight: "500",
                paddingRight: startTimer && !isOpen ? "5px" : "",
              }}
            >
              {startTimer && !isOpen
                ? `${hours <= 9 ? "0" : ""}${hours} :
                    ${minutes <= 9 ? "0" : ""}${minutes} `
                : "Attendance"}
            </span>
          </div>
        </DropdownToggle>
        <DropdownMenu right>
          <div
            className="thinScroll"
            style={{
              width: "440px",
              padding: "0px 0px 15px 0px",
              overflow: "auto",
            }}
          >
            <div
              className="d-flex justify-content-between align-items-center"
              style={{ padding: "14px" }}
            >
              <span
                className="text-start"
                style={{
                  fontSize: "18px",
                  color: "#262a44",
                  fontWeight: "500",
                  paddingLeft: "2%",
                }}
              >
                Attendance Timer
              </span>
              <span
                onClick={() => {
                  setIsOpen(!isOpen);
                }}
                style={{ cursor: "pointer", paddingRight: "2%" }}
              >
                <img src={CloseIcon} alt="" />
              </span>
            </div>
            <hr style={{ marginTop: "0", width: "100%" }} />

            <div className="d-flex align-items-center justify-content-center pr-4 pl-4 pb-4 pt-2">
              <div
                className="d-flex align-items-center justify-content-center flex-column"
                style={{ width: "85%" }}
              >
                {buttonName === "Check In" && (
                  <span
                    className="mb-2"
                    style={{
                      color: "#262a44",
                      fontWeight: "500",
                      fontSize: "16px",
                    }}
                  >
                    {getWellcomeMessage()}
                    {` ${loginData?.first_name}`}!
                  </span>
                )}
                {buttonName === "Check In" && (
                  <p
                    className="text-center"
                    style={{ color: "#6e7491", fontSize: "14px" }}
                  >
                    Click on below button to start your attendance tracking for
                    today.
                  </p>
                )}
                {buttonName !== "Check In" && (
                  <span style={{ color: "#6e7491" }}>
                    Timer for {moment(currentDate)?.format("DD MMM, YYYY")}
                    {" - "}
                    {new Date(currentDate)?.toLocaleDateString("en-US", {
                      weekday: "long",
                    })}
                  </span>
                )}
                {buttonName !== "Check In" && (
                  <span
                    style={{
                      color: "#262a44",
                      fontSize: "48px",
                      fontWeight: "600",
                    }}
                  >
                    {hours <= 9 ? "0" : ""}
                    {hours} : {minutes <= 9 ? "0" : ""}
                    {minutes} : {seconds <= 9 ? "0" : ""}
                    {seconds}
                  </span>
                )}
                <button
                  className={
                    startTimer
                      ? "btn btn-outline-danger mt-4 d-flex align-items-center justify-content-center"
                      : "btn btn-primary mt-4 d-flex align-items-center justify-content-center"
                  }
                  style={{ paddingRight: "16px" }}
                  onMouseOver={() => setButtonColor(true)}
                  onMouseOut={() => setButtonColor(false)}
                  onClick={() => {
                    handleStartTimer(buttonName);
                  }}
                >
                  <img
                    alt=""
                    style={{
                      filter: buttonColor ? "brightness(500%)" : "none",
                    }}
                    src={
                      buttonName === "Start Timer"
                        ? PlayIcon
                        : buttonName === "Stop"
                        ? StopIcon
                        : ""
                    }
                  />
                  <span className="ml-1">
                    {buttonName ? buttonName : "Check In"}
                  </span>
                </button>
              </div>
            </div>
            {buttonName !== "Check In" && (
              <AttendanceList
                attendenceData={attendenceData}
                totalAttendanceHours={totalAttendanceHours}
                fetching={fetching}
              />
            )}
          </div>
        </DropdownMenu>
      </ButtonDropdown>
      <Toaster />
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.auth.attendenceSuccess,
  error: state.auth.attendenceError,
  attendanceStatusCode: state.auth.attendanceStatusCode,
  statusCode: state.auth.statusCode,
  loginData: state.auth.loginData,
  attendenceData: state.auth.attendenceData,
  totalAttendanceHours: state.auth.totalAttendanceHours,
  latitude: state.auth.latitude,
  longitude: state.auth.longitude,
  location: state.auth.location,
  locationCityName: state.auth.locationCityName,
  startingAttendenceData: state.notification.attendence,
  fetching: state.auth.attendenceFetching,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetAttendanceDataAction: (data: GetAttendanceTimePayloadType) =>
    dispatch(getAttendanceDataAction(data)),
  dispatchAddAttendanceTimeAction: (data: AddAttendanceTimePayloadType) =>
    dispatch(addAttendanceTimeAction(data)),
  dispatchResetAttendenceData: () => dispatch(resetAttendenceData()),
  dispatchResetError: () => dispatch(resetAttendenceError()),
  dispatchResetAttendanceSuccess: () => dispatch(resetAttendenceSuccess()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetAttendanceStatusCode: () =>
    dispatch(resetAttendanceStatusCode()),
  dispatchResetScheduleNotificationCount: () =>
    dispatch(resetScheduleNotificationCount()),
  dispatchGetSchedulingNotificationCountAction: (
    data: GetSchedulingNotificationCountPayloadType
  ) => dispatch(getSchedulingNotificationCountAction(data)),
  dispatchSetLocationDetails: (data: any) => dispatch(setLocationDetails(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Attendance);
